import axios from 'axios';
// Get current locale from HTML lang attribute
var locale = document.documentElement.lang || 'az';
locale = '/' + locale;
// Main axios instance for redesign.insure.az
export default axios.create({
    //@ts-ignore
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': window.csrf_token, 'lang-code': locale },
    //@ts-ignore
    baseURL: "".concat(window.$domain || 'https://insure.az').concat(locale)
    //baseURL: 'http://192.168.6.35:8081'
});
// Alternative axios instance for insure.az (without redesign subdomain)
export var axiosMain = axios.create({
    //@ts-ignore
    headers: { 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': window.csrf_token, 'lang-code': locale },
    //@ts-ignore
    //baseURL: `https://insure.az${locale}`
    baseURL: "".concat(window.$prodDomain || 'https://insure.az').concat(locale)
});
